import React from 'react'
import type { LegalInfoProps } from '@/features/enrollment'

export default function PFASLegalInfo({ enrollmentData, updateEnrollmentData, errors }: LegalInfoProps) {
  return (
    <>
      {/* Legal Authorization */}
      <div className="col-span-full">
        <label className="flex items-start space-x-3 cursor-pointer">
          <input 
            type="checkbox" 
            name="legalAuthorization"
            className={`mt-1 h-5 w-5 rounded border-gray-300 text-accent-600 focus:ring-accent-500 ${errors.legalAuthorization ? 'border-red-500' : ''}`}
            checked={enrollmentData.legalAuthorization || false}
            onChange={(e) => updateEnrollmentData('legalAuthorization', e.target.checked)}
          />
          <span className="text-sm text-gray-700">
            I authorize the law firm to represent me in my PFAS contamination claim. <span className="text-red-500">*</span>
          </span>
        </label>
        {errors.legalAuthorization && (
          <p className="mt-1 text-sm text-red-600">{errors.legalAuthorization}</p>
        )}
      </div>

      {/* Attorney Representation */}
      <div className="col-span-full">
        <label className="block text-sm font-medium text-accent-700 mb-2">
          Do you currently have an attorney representing you for this claim? <span className="text-red-500">*</span>
        </label>
        <div className="space-y-2">
          <label className="flex items-center space-x-3 cursor-pointer">
            <input 
              type="radio" 
              name="hasAttorney"
              className="h-4 w-4 border-gray-300 text-accent-600 focus:ring-accent-500"
              value="yes"
              checked={enrollmentData.hasAttorney === 'yes'}
              onChange={(e) => updateEnrollmentData('hasAttorney', e.target.value)}
            />
            <span className="text-sm text-gray-700">Yes</span>
          </label>
          <label className="flex items-center space-x-3 cursor-pointer">
            <input 
              type="radio" 
              name="hasAttorney"
              className="h-4 w-4 border-gray-300 text-accent-600 focus:ring-accent-500"
              value="no"
              checked={enrollmentData.hasAttorney === 'no'}
              onChange={(e) => updateEnrollmentData('hasAttorney', e.target.value)}
            />
            <span className="text-sm text-gray-700">No</span>
          </label>
        </div>
        {errors.hasAttorney && (
          <p className="mt-1 text-sm text-red-600">{errors.hasAttorney}</p>
        )}
      </div>

      {/* Attorney Name (conditional) */}
      {enrollmentData.hasAttorney === 'yes' && (
        <div className="col-span-full">
          <label className="block text-sm font-medium text-accent-700 mb-2">
            Attorney Name <span className="text-red-500">*</span>
          </label>
          <input 
            type="text" 
            name="attorneyName"
            className={`input-field ${errors.attorneyName ? 'border-red-500' : ''}`}
            value={enrollmentData.attorneyName || ''}
            onChange={(e) => updateEnrollmentData('attorneyName', e.target.value)}
            placeholder="Enter attorney's full name"
          />
          {errors.attorneyName && (
            <p className="mt-1 text-sm text-red-600">{errors.attorneyName}</p>
          )}
        </div>
      )}
    </>
  )
}
